export const GLUE_DQ_TYPE = 'GlueDQ';
export const DATAFI_DQ_TYPE = 'DataFi';
export const DQ_RULE_PASS_STATUS = 'PASS';
export const DQ_RULE_FAIL_STATUS = 'FAIL';
